import { render, staticRenderFns } from "./Jury.vue?vue&type=template&id=9594e430&scoped=true&"
import script from "./Jury.vue?vue&type=script&lang=ts&"
export * from "./Jury.vue?vue&type=script&lang=ts&"
import style0 from "./Jury.vue?vue&type=style&index=0&id=9594e430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9594e430",
  null
  
)

export default component.exports